export const announcementsHeaderData = [
    {
        field: 'RowId',
        headerName: 'Row ID',
        width: '80',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'NewsDate',
        headerName: 'News Date',
        width: '150',
        hideInTable: false,
        isDisabled: false,
        sortable: true
    },
    {
        field: 'FeatureName',
        headerName: 'Feature Name',
        width: '200',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'Announcement',
        headerName: 'Announcement',
        width: '300',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'Status',
        headerName: 'Status',
        width: '85',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'CreatedBy',
        headerName: 'Created By',
        width: '140',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'CreatedDate',
        headerName: 'Created Date',
        width: '150',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'LastModifiedBy',
        headerName: 'Last Modified By',
        width: '140',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'LastModifiedDate',
        headerName: 'Last Modified Date',
        width: '150',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'Comment',
        headerName: 'Comment',
        width: '350',
        hideInTable: false,
        isDisabled: false,
    }
];

export const announcementsInitialState = {
    RowId: '',
    NewsDate: '',
    FeatureName: '',
    Announcement: '',
    Status: 'Inactive',
    CreatedBy: '',
    CreatedDate: '',
    LastModifiedBy: '',
    LastModifiedDate: '',
    Comment: ''
};

export const announcementsSearchState = {
    RowId: '',
    NewsDate: '',
    FeatureName: '',
    Announcement: '',
    Status: '',
    CreatedBy: '',
    CreatedDate: '',
    LastModifiedBy: '',
    LastModifiedDate: '',
    Comment: ''
};

export const announcementsApiEndpoint = {
    read: 'ADMIN_GetAnnouncements',
};
